import { AuthenticationRequiredError } from "@lib/access/access";

// checkResForError is a legacy helper that either throws an error that
// should be catched for redirection or returns a boolean corresponding to
// wether the response has an error or not.
const checkResForError = (res) => {
  if (res.status === 401) {
    throw new AuthenticationRequiredError();
  }
  return res.status >= 400;
};

export default checkResForError;
